
import { defineComponent } from 'vue'
import Message from 'primevue/message'

export default defineComponent({
    name: 'kn-admin-menu',
    components: { Message },
    emits: ['click'],
    props: {
        model: Array,
        openedPanelEvent: Object
    },
    data() {
        return {
            searchText: '',
            tmpModel: new Array<any>()
        }
    },
    mounted() {
        this.tmpModel = this.model || []
    },
    updated() {
        console.log('update')
        //@ts-ignore
        if (this.$refs.megamenu) this.$refs.megamenu.style.top = this.openedPanelEvent.target.getBoundingClientRect().top + 'px'
    },
    methods: {
        filter() {
            const modelToFilter = this.model || []
            this.tmpModel = modelToFilter.filter((groupItem: any) => {
                let childItems = groupItem.items.filter((item) => item.label.toLowerCase().includes(this.searchText.toLowerCase()))
                return childItems.length > 0
            })
        },
        focusInput(e) {
            e.stopImmediatePropagation()
        },
        onLeafClick(event, item, navigate) {
            if (item.disabled) {
                event.preventDefault()
                return
            }
            if (item.to && navigate) {
                this.$emit('click', {
                    originalEvent: event,
                    navigate: navigate,
                    item: item
                })
            }
            if (item.command) {
                this.$emit('click', {
                    originalEvent: event,
                    navigate: navigate,
                    item: item
                })
            }
        }
    },
    computed: {}
})
